import { useQuery } from '@tanstack/react-query'
import { getUserRoles } from '@/lib/utils/supabase/auth'

export function useUserRoles(userId: string | undefined) {
  const {
    data: roles = [] as string[],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['userRoles', userId],
    queryFn: () => getUserRoles(userId as string),
    enabled: !!userId,
    gcTime: 1000 * 60 * 30, // Keep data in cache for 30 minutes
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
  })

  const checkRole = (role: string): boolean => {
    if (!userId) return false
    return roles.includes(role)
  }

  const checkAnyRole = (rolesToCheck: string[]): boolean => {
    if (!userId) return false
    return rolesToCheck.some(role => roles.includes(role))
  }

  const checkAllRoles = (rolesToCheck: string[]): boolean => {
    if (!userId) return false
    return rolesToCheck.every(role => roles.includes(role))
  }

  return {
    roles,
    isLoading,
    error,
    checkRole,
    checkAnyRole,
    checkAllRoles,
  }
} 